<script setup>
// import arrow from 'assets/icons/right.svg?component'

const props = defineProps({
    carouselConfig: {
        type: Object,
        required: true,
        default: () => ({}),
        validator(value) {
            const validations = {
                items: value => typeof value?.items === 'object' && Array.isArray(value?.items),
                type: value => value?.type === undefined || typeof value?.type === 'string',
                placeholder: value => value?.placeholder === undefined || typeof value?.placeholder === 'boolean'
            }

            return Object.entries(validations).every(([_, validation]) => validation(value))
        }
    }
})

const swiper = ref(null)

useSwiper(swiper, {
    loop: false,
    lazy: true,
    // redesign (CN-12074): arrows removed for now, the pagination dots are the click control
    // navigation: {
    //     prevEl: `.${props.carouselConfig?.type}-prev`,
    //     nextEl: `.${props.carouselConfig?.type}-next`
    // },
    pagination: {
        enabled: true,
        clickable: true,
        el: `.${props.carouselConfig?.type}-pagination`
    },
    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 16,
    breakpoints: {
        768: {
            centeredSlides: true,
            slidesPerView: 1.77,
            spaceBetween: 30
        },
        1024: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30
        }
    }
})
</script>

<template>
    <section v-if="carouselConfig.items?.length > 0" class="carousel-teaser-container">
        <ClientOnly>
            <swiper-container ref="swiper" :init="false">
                <swiper-slide v-for="{ teaser } in carouselConfig.items" :key="teaser.uid">
                    <CarouselTeaserItem :carousel-teaser-item="{ ...teaser, ...{ placeholder: carouselConfig?.placeholder } }" />
                </swiper-slide>
            </swiper-container>

            <div class="swiper-controls-container custom-swiper-controls-container">
                <!-- <div class="swiper-button-prev custom-swiper-button-prev" :class="`${carouselConfig.type}-prev`">
                    <arrow />
                </div> -->

                <div class="swiper-pagination custom-swiper-pagination" :class="`${carouselConfig.type}-pagination`" />

                <!-- <div class="swiper-button-next custom-swiper-button-next" :class="`${carouselConfig.type}-next`">
                    <arrow />
                </div> -->
            </div>
        </ClientOnly>
    </section>

    <!-- <DevOnly>
        <pre>{{ carouselConfig }}</pre>
    </DevOnly> -->
</template>

<style lang="scss">
.carousel-teaser-container {
    margin-block-end: px2rem(60);

    @include bp(medium1) {
        margin-block-end: px2rem(70);
    }

    @include bp(large1) {
        margin-block-end: px2rem(90);
    }
}

.custom-swiper-controls-container {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 44px;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-block-start: 30px;

    @include bp(large1) {
        margin-block-start: 60px;
    }
}

.custom-swiper-button-prev,
.custom-swiper-button-next {
    position: static;
    display: none;
    justify-content: center;
    align-items: center;
    margin-block-start: 2px;
    width: 44px;
    transition: opacity 400ms ease;
    cursor: pointer;

    @include bp(large1) {
        display: flex;
    }

    &::after {
        content: '';
    }

    > svg {
        height: 25px;
    }

    &.swiper-button-disabled {
        opacity: 0;
    }
}

.custom-swiper-button-prev {
    rotate: 180deg;
}

.custom-swiper-pagination {
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    // 16px target + 8px gap = 24px between centers, the WCAG 2.5.8 minimum now that the dots are the only control
    @include bp(large1) {
        gap: 8px;
    }

    // redesign (CN-12074): the bullet keeps its old size and gap as click target (a11y),
    // only the drawn dot shrinks to the Figma sizes (inactive 6px, active 10px)
    .swiper-pagination-bullet {
        display: grid;
        place-items: center;
        width: 10px;
        height: 10px;
        background: transparent;
        cursor: pointer;
        opacity: 1;

        @include bp(large1) {
            width: 16px;
            height: 16px;
        }

        &::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background: $carousel-teaser-dots-bg;
            transition: width 400ms ease, height 400ms ease, background-color 400ms ease;
        }

        &.swiper-pagination-bullet-active::before {
            width: 10px;
            height: 10px;
            background: $carousel-teaser-dots-active-bg;
        }
    }
}
</style>
